import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { operationId } from './transferModel.mjs';

export default function TransferPanel({ title, toggleLabel, children, actions, notice, className = '', defaultExpanded = true }) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const [contentId] = useState(() => `transfer-panel-${operationId()}`);

  return <Box className={`transfers-panel ${className}`}>
    <Box className="transfers-editor-header transfers-panel-header">
      <Typography component="h3" className="transfers-section-title">{title}</Typography>
      <Box className="transfers-panel-actions">
        <Button className="transfers-button transfers-button--text" aria-expanded={expanded}
          aria-controls={contentId} aria-label={`${expanded ? 'Replier' : 'Déplier'} ${toggleLabel}`}
          endIcon={<FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} />}
          onClick={() => setExpanded(value => !value)}>
          {expanded ? 'Replier' : 'Déplier'}
        </Button>
        {actions}
      </Box>
    </Box>
    {notice}
    {/* Garder les champs montés préserve les saisies et les listes déjà chargées. */}
    <Box id={contentId} className="transfers-panel-content" hidden={!expanded}>
      {children}
    </Box>
  </Box>;
}
